export const SHOW_POPUP = 'SHOW_POPUP';
export const HIDE_POPUPS = 'HIDE_POPUPS';
export const UPDATE_POPUP = 'UPDATE_POPUP';

export const DEFAULT_POPUP_TIMEOUT_SECONDS = 5;
